import { defaultHttpClient } from '../../httpClient';
import type { GoodsOption } from '../types';

export type DeliveryType = 'shak' | 'today' | 'standard' | 'third_pl';

export interface OptionComponent {
  option_minimum_additional_price: number;
  goods_option: GoodsOption | null;
  has_high_demand_tag: boolean;
  is_final_depth: boolean;
  image_url: string | null;
  color_code: string | null;
  standard_delivery_message: string | null;
  goods_option_sno: number;
  depth: number;
  sno: number;
  wholesale_name: string | null;
  delivery_lead_days: number | null;
  name: string;
  delivery_type: DeliveryType;
}

export interface GoodsOptionsResponse {
  name: string;
  sales_method?: 'PRE_ORDER' | null;
  option_components: OptionComponent[];
}

export const getGoodsOptions = (
  goodsSno: number,
  params?: { depth: number; selected_option_sno?: number },
) => {
  return defaultHttpClient
    .request<GoodsOptionsResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/options/`,
      params,
    })
    .then(result => result.data);
};
